<template>
  <div v-if="callData">
    <v-dialog v-if="!isMinimize" v-model="dialog" :max-width="callData.action == callStatus.Connected ? '90%' : '300'"
      persistent origin="left bottom" content-class="dialog-call">
      <v-card class="hide-overflow box-dialog" style="position: relative;">
        <v-toolbar absolute dark color="white" class="px-2 dialog-toolbar">
          <v-toolbar-title class="black--text headline">
            {{ callData.number }}
            <span v-if="callData.action == callStatus.Connected"
              class="primary--text subheading pl-1 font-weight-bold">Đang trong cuộc gọi</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click="createCase">Tạo case</v-btn>
          <v-btn icon dark @click="isMinimize = true">
            <v-icon color="primary">fa fa-compress</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="box-scroll scroll-y" v-if="isLoadedCompany">
          <div v-if="company">
            <company-info :data="company" />
            <div class="tabs_bar">
              <v-tabs color="primary" dark slider-color="yellow" fixed-tabs>
                <v-tab ripple>Bitrix24 CRM</v-tab>
                <v-tab ripple>Suite CRM</v-tab>
                <v-tab ripple>Billing</v-tab>
                <v-tab ripple>Admin Tool</v-tab>
                <v-tab ripple>New SC</v-tab>
                <v-tab-item>
                  <v-card flat>
                    <crm-bitrix :phoneNumber="
                      callData.number && callData.number.toString()
                    " :trackingId="company.Id"></crm-bitrix>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <crm-info :trackingId="company.Id"></crm-info>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <billing-statuses :name="company.Name" :id="company.Id"></billing-statuses>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <admin-tool :name="company.Name" :vehicles="company.Vehicles" :devices="company.Devices"></admin-tool>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <sim :name="company.Name" :vehicles="company.Vehicles" :devices="company.Devices"></sim>
                  </v-card>
                </v-tab-item>
                <v-tab-item>
                  <v-card flat>
                    <new-s-c :name="company.Name" :vehicles="company.Vehicles" :devices="company.Devices"></new-s-c>
                  </v-card>
                </v-tab-item>
              </v-tabs>
            </div>
          </div>
          <div class="pt-5 text-xs-center" v-else>
            <p class="display-1 font-weight-bold">Not found!</p>
            <p class="title font-weight-regular">
              Không tìm thấy dữ liệu của khách hàng.
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="dialog-minimize" v-else-if="dialog">
      <v-toolbar class="px-3" dark color="white" style="box-shadow: none" height="52px">
        <v-toolbar-title class="black--text subheading">
          {{ callData.number }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="isMinimize = false" v-if="callData.action !== callStatus.Ringing">
          <v-icon color="primary" size="18px">fa fa-expand</v-icon>
        </v-btn>
        <v-btn icon dark @click="close">
          <v-icon color="black">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="py-0">
        <span v-if="callData.action == callStatus.Connected" class="primary--text subheading font-weight-bold">Đang trong
          cuộc gọi</span>
        <span v-if="callData.action == callStatus.Ringing" class="green--text subheading font-weight-bold">Đang gọi đến
          <loading type="dots" />
        </span>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { CallStatus } from '@/utils/index';
import Loading from '@/components/Loading';
import CompanyInfo from '../pages/search/components/CompanyInfo';
import CrmInfo from '../pages/search/components/CrmInfo';
import BillingStatuses from '../pages/search/components/BillingStatuses';
import AdminTool from '../pages/search/components/AdminTool';
import CrmBitrix from '../pages/search/components/CrmBitrix';
import NewSC from '../pages/search/components/NewSC';

import { mapActions, mapGetters } from 'vuex';

export default {
  components: {
    Loading,
    CompanyInfo,
    CrmInfo,
    BillingStatuses,
    AdminTool,
    CrmBitrix,
    NewSC,
  },

  props: {},

  data: () => ({
    dialog: false,
    callData: null,
    callStatus: CallStatus,
    company: null,
    isMinimize: false,
    toggleMinimize: false,
    isLoadedCompany: false,
  }),

  computed: {
    ...mapGetters(['accountCRM']),
  },

  methods: {
    ...mapActions(['SearchCompanyByPhone']),
    open (data) {
      if (data) {
        this.callData = data;
        this.isMinimize = this.callData.action === this.callStatus.Ringing;
        this.dialog = true;
        this.getCompany();
      }
    },

    close () {
      this.dialog = false;
      this.$emit('endCall');
    },

    async getCompany () {
      this.isLoadedCompany = false;
      let res = await this.SearchCompanyByPhone({
        Phone: this.callData.number,
      }).catch(() => {
        return null;
      });
      this.company = res && res.Company;
      if (this.company) {
        this.company.Sale = res.Company.Sale.Email;
      }
      this.isLoadedCompany = true;
    },

    minimize () {
      this.isMinimize = true;
    },

    createCase () {
      // let link = 'http://vmcrm.quanlyxe.vn/index.php?action=ajaxui#ajaxUILoc=index.php%3Fmodule%3DCases%26action%3DEditView%26return_module%3DCases%26return_action%3DDetailView';
      let link =
        'https://crm.vietmap.vn/services/lists/18/element/0/0/?external_context=creatingElementFromCrm&fieldId=PROPERTY_84';
      if (this.company) {
        // link += '%26account_id%3D' + this.accountCRM.Id + '%26account_name%3D' + this.accountCRM.Name;
        link += '&defaultValue=C_' + this.company.CrmContactId;
      }
      window.open(link, '_blank');
    },
  },
};
</script>

<style>
.dialog-call .box-dialog {
  height: calc(100vh - 180px);
  background-color: #fff;
}

.dialog-call {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1), max-width 0s !important;
}

.dialog-call .box-scroll {
  height: 100%;
  padding-top: 64px;
}

.dialog-minimize {
  position: fixed;
  left: 0;
  bottom: 0;
  height: 104px;
  transition: max-width 0s !important;
  margin: 24px;
  width: 300px;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
}

.dialog-minimize .v-toolbar__content {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.v-bottom-sheet {
  position: fixed;
  flex: none !important;
  min-width: auto !important;
  width: 300px;
  max-height: none;
  height: 104px;
  bottom: 0;
  left: 0;
  margin: 20px !important;
}

.v-tabs__bar {
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/DialogCallCenter.vue